import { type Enum } from '@webapp/utils'

export const AttachmentTypes = {
  PACKING_SLIP: 'packingslip',
} as const
export type AttachmentType = Enum<typeof AttachmentTypes>
